import { render, staticRenderFns } from "./EssentialsColorSelect.vue?vue&type=template&id=a79a317a&scoped=true&"
import script from "./EssentialsColorSelect.vue?vue&type=script&lang=js&"
export * from "./EssentialsColorSelect.vue?vue&type=script&lang=js&"
import style0 from "./EssentialsColorSelect.vue?vue&type=style&index=0&id=a79a317a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79a317a",
  null
  
)

export default component.exports